import { render, staticRenderFns } from "./TabViewList.vue?vue&type=template&id=b930a356&"
import script from "./TabViewList.vue?vue&type=script&lang=js&"
export * from "./TabViewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports